(() => {
  const root = document.querySelector('pt-mobile-browse-dock');
  if (!root || root.dataset.ready || !window.HTMLDialogElement) return;
  root.dataset.ready = 'true';
  // Escape the header section's stacking context without duplicating menu data.
  document.body.append(root);
  const mobile = window.matchMedia('(max-width: 767.98px)');
  const dialogs = [...root.querySelectorAll('dialog')];
  let opener;
  let active;
  const close = (restoreFocus = true) => {
    if (!active) return;
    active.close();
    active = null;
    document.documentElement.classList.remove('pt-browse-open');
    opener?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) opener?.focus({ preventScroll: true });
  };
  const sync = () => {
    const blocked = document.body.matches('.reveal-mobile-nav, .show-search')
      || document.documentElement.classList.contains('gallery-viewer-open')
      || !!document.querySelector('.js-overlay.is-visible, .drawer[open], .filter-container--show-filters-mobile, .modal[open], [open]:not(.is-closing) .modal');
    root.toggleAttribute('data-overlay', blocked);
    if (blocked || !mobile.matches) close(false);
  };
  root.addEventListener('click', (event) => {
    const button = event.target.closest('button[aria-controls]');
    if (!button || !mobile.matches || root.hasAttribute('data-overlay')) return;
    close(false);
    opener = button;
    active = dialogs.find(dialog => dialog.id === button.getAttribute('aria-controls'));
    active.showModal();
    button.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('pt-browse-open');
    active.querySelector('[data-close]').focus();
  });
  dialogs.forEach(dialog => {
    dialog.querySelector('[data-close]').addEventListener('click', () => close());
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button, a[href]')];
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientY < rect.top || event.clientX < rect.left || event.clientX > rect.right) close();
    });
  });
  // Observe only existing overlay state, never alter cart/menu behavior.
  const observer = new MutationObserver(sync);
  [document.body, document.documentElement, ...document.querySelectorAll('.js-overlay, .drawer, filter-container, .modal, modal-dialog, details:has(.modal)')]
    .forEach(element => observer.observe(element, { attributes: true, attributeFilter: ['class', 'open'] }));
  mobile.addEventListener('change', sync);
  window.addEventListener('pagehide', () => close(false));
  root.hidden = false;
  sync();
})();
